<template>
    <Card>
        <div class="card-body d-flex flex-wrap" style="gap: .5rem;">
            <router-link class="btn btn-link" :to="{ name: 'CreateIntegrationPage' }">
                <i class="icon-plus3 mr-2"></i>
                {{ $t('buttons.create') }}
            </router-link>
            <router-link class="btn btn-link" :to="{ name: 'CompareIntegrationsPage' }">
                <i class="icon-image-compare mr-2"></i>
                {{ $t('buttons.compareIntegrations') }}
            </router-link>
        </div>
        <FetchTable :handle="tableHandle" :url="table.url" :columns="table.columns" v-model:orders="table.orders">
            <template #td-name="{row}">
                <RouterLink :to="{ name: 'MainInformation', params: { integrationUuid: row.uuid } }">{{ row.name }}</RouterLink>
            </template>
            <template #td-type="{row}">
                {{ row.service === IntegrationServiceEnum.SUPPLIER ? $t('labels.type_supplier') : $t('labels.type_marketplace') }}
            </template>
            <template #td-service="{row}">
                {{ row.service === IntegrationServiceEnum.SUPPLIER ? row.dropshipper?.external_source_service : row.service }}
            </template>
            <template #td-integration_categories_count="{row}">
                <router-link :to="{
                    name: 'CategoriesCard',
                    params: { integrationUuid: row.uuid }
                }">
                    {{ row.integration_categories_count }}
                </router-link>
            </template>
            <template #td-integration_product_items_count="{row}">
                <router-link :to="{
                    name: 'IntegrationProductsTable',
                    params: { integrationUuid: row.uuid }
                }">
                    {{ row.integration_product_items_count }}
                </router-link>
            </template>
        </FetchTable>
    </Card>
</template>
<script>
import Card from '../../../components/new/CardComponent.vue';
import { mapGetters } from 'vuex';
import DateFormatter from "../../../services/DateFormatter"
import FetchTable from "../../../components/new/table/FetchTable.vue";
import { createTableHandle } from "../../../components/new/table/tableHandle";
import { IntegrationServiceEnum } from '../../enums/IntegrationServiceEnum';

export default {
    name: 'IntegrationIndexPage',
    components: {
        Card, FetchTable
    },
    data() {
        return {
            tableHandle: createTableHandle(),
            DateFormatter,
            IntegrationServiceEnum,
            table: {
                url: `/projects/${this.$route.params.projectUuid}/pim/channels`,
                orders: [],
                columns: [
                    {key: 'id', name: this.$t('table.titles.id'), width: '80px', type: 'string', order: true},
                    {key: 'name', name: this.$t('table.titles.name'), width: 'auto', type: 'string', order: true},
                    {key: 'type', name: this.$t('table.titles.type'), width: 'auto', type: 'string', order: false},
                    {key: 'service', name: this.$t('table.titles.service'), width: 'auto', type: 'string', order: true},
                    {key: 'integration_categories_count', name: this.$t('table.titles.categories'), width: 'auto', type: 'string', order: false},
                    {key: 'integration_product_items_count', name: this.$t('table.titles.publications'), width: 'auto', type: 'string', order: false},
                    {key: 'created_at', name: this.$t('table.titles.created_at'), width: 'auto', type: 'string', order: true},
                ],
            }
        }
    },
    computed: {
        ...mapGetters('route', ['project'])
    },
    mounted() {
        this.tableHandle.fetchRows({
            extra_fields: ['categoriesCount', 'productsCount']
        });
    }
}
</script>
